export default {
  buttons: {
    small: "6px",
    large: "8px",
  },
  cards: {
    large: "12px",
    medium: "8px",
    popup: "8px",
  },

  extraSmall: 6,
  small: 8,
  medium: 16,
  large: 20,
};
